import styled from 'styled-components';
import { AnimatedContainer } from '../styles';

export const MainContainer = styled(AnimatedContainer)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const HeaderContainer = styled.div`
  max-width: 382px;
  width: 100%;

  > h1 {
    color: ${props => props.theme.colors.grey};
    margin-bottom: 16px;
    margin-top: 56px;
    font-weight: 600;
    font-size: 30px;
  }
`;

export const AppStoreImageContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  align-items: center;

  margin-top: 72px;
  margin-bottom: 237px;

  img {
    width: 410px;
    height: 84px;
  }
`;

export const ImageContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  align-items: center;

  img {
    width: 244px;
    height: 281px;
  }
`;

export const TextContainer = styled.div`
  max-width: 382px;

  span {
    font-weight: 500;
    fon-size: 17px;
    line-height: 25px;
    color: ${({ theme }) => theme.colors.grey1};
  }

  margin-top: 54px;
`;
